import React, { type FC, type PropsWithChildren } from 'react'

import { useAtom } from 'jotai'
import { Loading } from 'mailup-web-components'

import { pageState } from 'State/page'

import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'

interface PageProps {
  className?: string
  onReload: () => void | Promise<void>
}

const Page: FC<PropsWithChildren<PageProps>> = ({
  children,
  className,
  onReload,
}) => {
  const [{ status, loading, errorMessage }] = useAtom(pageState)

  return (
    <>
      <Loading open={loading} />

      <PageContainer className={className}>
        {status === 'error' ? (
          <ErrorFeedback onReload={onReload}>{errorMessage}</ErrorFeedback>
        ) : status === 'ready' || status === 'fetching' ? (
          children
        ) : null}
      </PageContainer>
    </>
  )
}

export default Page
